module.exports = __webpack_public_path__ + "img/exocitosis.4e46a98e.jpg";